import {Typography} from '~library/atoms/Typography';
import './MobileBox.sass';

export const MobileBox = ({title, children}) => (
  <div className="mobile-box">
    <div className="mobile-box__header">
      <div className="mobile-box__header__title">
        <Typography as="h1" variant="paragraph4" size="medium" color="pebble">
          {title}
        </Typography>
      </div>
    </div>
    <div className="mobile-box__body">{children}</div>
  </div>
);
